import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum FeatureOnboardingType {
  PACKAGE_PROTECTION_PLUS = "package_protection_plus",
  EXPANDED_WARRANTY = "extended_warranty",
  CONVERSION = "conversion",
  MANAGED_RETURNS = "managed_returns",
  INTERCOM_MOVED = "intercom_moved",
  DISABLED = "disabled",
  SUPPORT_TO_AI_UPSELL = "support_to_ai_upsell",
  COMMENTSOLD_REDO = "commentsold_redo",
  SHOPPER_AI_WRAPPED = "shopper_ai_wrapped",
  HELP_ICON_MOVING = "help_icon_moving",
}

export const FeatureOnboardingConfigSchema = z.object({
  dismissals: z.number(),
  lastDismissal: z.iso.datetime().nullish(),
  completed: z.boolean().optional(),
});

export const UserOnboardingSchema = z.object({
  _id: zExt.objectId(),
  userId: zExt.objectId(),
  type: createEnum(FeatureOnboardingType, {
    enumName: "FeatureOnboardingType",
  }),
  viewHistory: FeatureOnboardingConfigSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const UpsertUserOnboardingSchema = z.object({
  userId: zExt.objectId(),
  type: createEnum(FeatureOnboardingType, {
    enumName: "FeatureOnboardingType",
  }),
  viewHistory: FeatureOnboardingConfigSchema,
});

export type UserOnboarding = z.infer<typeof UserOnboardingSchema>;
export type UpsertUserOnboarding = z.infer<typeof UpsertUserOnboardingSchema>;
export type FeatureOnboardingConfig = z.infer<
  typeof FeatureOnboardingConfigSchema
>;
